<template>
    <div class="modal-tv-detail" v-if="!$store.state.emptyBox">



        <div class="modal-tv-container" v-if="!$store.state.loading">
            <div class="title-block" style="display: none;">
                {{names.name}} {{getCurrentBox.name}} ({{names.tv}})
            </div>

            <div class="desc-block">
                {{getCurrentBox.description}}
            </div>

            <!--<div class="button-row">-->
            <!--<a class="btn btn--l btn--accent btn--border" href="/channel_packages/">Назад-->
            <!--</a>-->
            <!--</div>-->


            <template v-if="getCurrentBox && getCurrentChannels !== 'Waiting'">

                <div class="channels">
                    <div class="subtitle">
                        <span>Телеканалы в подписке</span>

                        <div class="select-block" :class="{'active' : isSelecting}">
                            <div class="select-toggle" @click="isSelecting = !isSelecting">{{selected}}</div>
                            <div class="select-list" v-show="isSelecting">

                                <div
                                        class="select-item"
                                        :class="all"
                                        @click="selectedFunc('Все категории')">Все категории</div>
                                <div class="select-item"
                                     v-for="channelCat in getCurrentChannels"
                                     :class="(channelCat) ? channelCat.class : ''"
                                     @click="selectedFunc(channelCat.category_name)"
                                >
                                    {{channelCat.category_name}}
                                </div>
                            </div>
                        </div>



                    </div>

                    <div class="category-block " :class="category.class" v-for="category in getCurrentChannels">
                        <div class="category-name">{{category.category_name}}</div>
                        <div class="channels-row">


                            <div class="channel-wrap" v-for="channel in category.channels">
                                <div class="channel" :style="{'background-image': 'url(' + channel.cover.bg + ')'}">
                                    <img :src="channel.cover.color_bg" :alt="channel.name" :title="channel.name">
                                </div>
                                <span class="channel-name">{{channel.name}}</span>


                            </div>


                        </div>
                    </div>

                </div>
            </template>

        </div>

        <div class="loader" v-else>
            <span>Загрузка...</span>
        </div>

    </div>
    <div v-else>
        <div class="no-packet-wrapper">
        <span class="no-packet">
                Данного пакета не существует!
        </span>
            <a href="/channel_packages/">Посмотреть доступные пакеты</a>
        </div>
    </div>

</template>

<script>
    import router from '@/router'

    import {mapGetters, mapMutations} from 'vuex'

    export default {
        name: 'SubElement',
        data() {
            return {
                selected: 'Все категории',
                all: 'visible-category',
                filteredArr: '',
                isSelecting: false,

                names: {}
            }
        },
        async mounted() {

            const res = await
                fetch(
                    "http://m9com.ru/wp-content/api24tv/getAllTV.php?detail=y&tv=" + encodeURI(this.$route.query.tv)
                );
            const posts = await res.json();
            this.names = posts[0];


            await this.$store.commit('globalPacketId', this.$route.query.package);
            this.$store.commit('loadPacket');




            document.addEventListener('click', (target) => {
                if(target){
                    if (
                        target.path[0].classList.contains('select-block')
                        || target.path[1].classList.contains('select-block')
                        || target.path[2].classList.contains('select-block')) {
                    }
                    else{

                        this.isSelecting = false;
                    }
                }

            })
        },
        watch: {
            getCurrentBox(el){
         //        if(el){
        //
         //            document.querySelector('nav.breadcrumbs').innerHTML = `
        //
		// <a href="/" class="p p--small breadcrumbs__link">Главная</a>
		// 			<a href="/channel_packages/" class="p p--small breadcrumbs__link">Пакеты каналов – M9</a>
         //    ` + `<a class="p p--small breadcrumbs__link current-link">`
         //                + this.getCurrentBox.name + `</a>`;
        //
         //        }

            },
            selected() {
                if (this.selected === 'Все категории') {
                    this.all = 'visible-category'
                    this.getCurrentChannels.forEach(el => {
                        el.class = 'visible-category not-current';
                    });
                    this.$store.commit('filterCurrent', {
                        pos: false
                    });
                }
                else {
                    this.all = 'hidden-category'
                    this.getCurrentChannels.forEach(el => {
                        if(el.category_name === this.selected){
                            el.class = 'visible-category';
                            this.$store.commit('filterCurrent', {
                                pos: true
                            });
                        }
                        else{
                            el.class = 'hidden-category'
                        }
                    })
                }
            }
        },
        computed: {
            ...mapGetters(['getCurrentBox', 'getCurrentChannels', 'fChannels']),

            filterList() {
                return this.getCurrentChannels.map(el => {
                    if(el.category_name !== this.selected){
                        return el.category_name;
                    }
                }) ;
            }

        },
        methods: {

            routerBack(){
                router.replace({ path: '/' })
            },

            selectedFunc(el){

                this.selected = el;
                this.isSelecting = !this.isSelecting;
            },

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

    .select-list{
        .hidden-category{
            display: block !important;
        }

    }
    .hidden-category{
        display: none !important;
    }
    .loader {
        width: 100%;
        height: 100%;
        z-index: 100;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        color: #15151c;
        font-size: 36px;
    }
    .desc-block {
        font-size: 20px;
        margin-top: 30px;
    }
    .subtitle {
        color: #15151c;
        font-weight: bold;
        font-size: 26px;
        margin-bottom: 25px;
        margin-top: 50px;
    }

    .channels-row {
        display: flex;
        flex-wrap: wrap;
        color: #15151c;
        margin-left: -15px;
        margin-right: -15px;
    }

    .channel-wrap {
        width: 12.5%;
        padding-left: 15px;
        padding-right: 15px;
        margin-bottom: 30px;
        .channel {
            height: 125px;
            width: 100%;
            -webkit-background-size: cover;
            background-size: cover;
            background-position: center center;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 7px;
            img {
                max-width: 100%;
                height: auto;
            }
            span {

            }
        }
    }

    .title-block {
        font-size: 36px;
        color: #15151c;
        font-weight: bold;
    }

    .align-self-center {
        align-self: center;

    }

    .align-self-bottom {
        align-self: end;
    }

    .container {
        width: 1400px;
        margin-left: auto;
        margin-right: auto;
    }

    .button-row {
        margin-top: 50px;
    }

    .modal-tv-detail {
        /*position: fixed;*/
        /*padding-top: 50px;*/
        /*padding-bottom: 50px;*/
        /*left: 0;*/
        /*top: 0;*/
        /*width: 100%;*/
        /*background-color: rgba(255, 255, 255, .95);*/
        /*height: 100%;*/
        /*overflow-y: scroll;*/
    }

    .channel-name {
        display: block;
        width: 100%;
        font-size: 1.4rem;
        text-align: center;
        margin-top: 10px;
    }

    .modal-tv-container {
        /*padding-left: 40px;*/
        /*padding-right: 40px;*/
    }


</style>
